import { actionTypes } from '../constants/AnalyticsGa4Constants';

const trackPageView = () => {
  return {
    type: actionTypes.TRACK_PAGE_VIEW
  };
};

export { trackPageView };
